export type Filter = {
    type: FilterTypes;
    value?: string | number | boolean;
}

export enum FilterTypes {
    MATCH = 'match',
    ONLINE = 'online',
    OFFLINE = 'offline',
    GROUP = 'group'
}